import React, { Component } from 'react';

export default class GeneralSettings extends Component {
    render() {
        return 'General Settings';
    }
}
